/* eslint-env browser */
/* eslint max-statements: [2, 10], max-depth: [2, 4], max-params: [2, 3], max-nested-callbacks: [2, 2], complexity: [2, 4] */

// @TODO: Do we need to clean up the canvas when we've finished using it?
var canvas = document.createElement('canvas')
var ctx = canvas.getContext('2d')

// Given the user is uploading a photo
// When the file has been converted to an img
// Then resize the img to have maximum dimensions of 1000px
// And upload it to the server
//
// Given the application is not running in production
// And this function is invoked
// When `e` is not an img.onload event
// Then thow an assertion error
//
// Given the application is not running in production
// And this function is invoked
// When `this` is not bound to a file input
// Then thow an assertion error

module.exports = function (e, cb) {
  // console.assert(e.target instanceof HTMLImageElement && e.type === 'onload', 'Expected an img.onload event, got ' + e)
  // console.assert(this instanceof HTMLInputElement && this.type === 'file', 'Expected `this` binding to be an instance of HTMLInputElement and type attribute "file", got ' + this)

  var img = e.target
  var w = img.width
  var h = img.height
  var max = 1000
  var ratio = h / w

  if (max < h && ratio > 1) (h = max, w = h / ratio)
  else if (max < w) (w = max, h = w * ratio)

  canvas.width = w
  canvas.height = h

  ctx.drawImage(
    img,
    0, 0, img.width, img.height,
    0, 0, w, h
  )

  function returnBlob (blob){
    cb(blob)
  }
  canvas.toBlob(returnBlob.bind(this), 'image/jpeg')
}